import {useState, useEffect} from 'react';
import { changeDisable, setMaskGeneric, validateEmail, dateToday, getPermission, showMessageError } from '../../../classes/functions';
import './companies.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaArrowAltCircleLeft, FaCog } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import { cnpj as CNPJlib } from 'cpf-cnpj-validator';

export default function Companies(){
  const { option, id } = useParams();
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);

  const [listCidades, setListCidades] = useState([]);
  const [listEstados, setListEstados] = useState([]);
  const [listPaises, setListPaises] = useState([]);
  const [listGrupos, setListGrupos] = useState([]);

  const [cnpj, setCnpj] = useState('');
  const [cnae, setCnae] = useState('');
  const [razao_social, setRazaoSocial] = useState('');
  const [nome_fantasia, setNomeFantasia] = useState('');
  const [cep, setCep] = useState('');
  const [logradouro, setLogradouro] = useState('');
  const [numero, setNumero] = useState('');
  const [bairro, setBairro] = useState('');
  const [complemento, setComplemento] = useState('');
  const [pais, setPais] = useState('');
  const [estado, setEstado] = useState('');
  const [cidade, setCidade] = useState('');
  const [grupo, setGrupo] = useState('');
  const [inscricao_estadual, setInscricaoEstadual] = useState('');
  const [inscricao_municipal, setInscricaoMunicipal] = useState('');
  const [telefone, setTelefone] = useState('');
  const [contato, setContato] = useState('');
  const [email_contato, setEmailContato] = useState('');
  const [email_nfe, setEmailNFE] = useState('');
  const [email_boleto, setEmailBoleto] = useState('');
  const [cliente_desde, setClienteDesde] = useState('');
  const [situacao, setSituacao] = useState('');
  const [observacao, setObservacao] = useState('');

  useEffect(()=> {
    async function loadCompanies(){
      if (id) { 
        getOne(id, option);
      } else {
        setClienteDesde(dateToday());
      }

      getData();
    }
    loadCompanies();

  },[]);

  function validForm() {
    if (!validateEmail(email_boleto)) {
      toast.error('E-mail boleto inválido');
      return false;
    }

    if (!validateEmail(email_contato)) {
      toast.error('E-mail contato inválido');
      return false;
    }

    if (!validateEmail(email_nfe)) {
      toast.error('E-mail nfe inválido');
      return false;
    }

    if ((cnpj !== '') && (razao_social !== '') && (nome_fantasia !== '') && (cep !== '') && (logradouro !== '') && (bairro !== '') && (pais !== '') && (estado !== '') && (cidade !== '') && (grupo !== '') && (telefone !== '') && (email_contato !== '')) {
      return true;
    } else {
      toast.error('Preencha todos os campos com * antes de salvar.');
      return false;
    }
  }

  function save(e){
    setCarrying(true);
    e.preventDefault();
     
    if (!validForm()) {
      setCarrying(false);
      return false;
    }

    console.log(cnpj.replace(/[./-]/g, ""))

    const data = {
      row: {
        cnpj: cnpj.replace(/[./-]/g, ""),
        cnae: cnae,
        razao_social: razao_social,
        nome_fantasia: nome_fantasia,
        cep: cep,
        logradouro: logradouro,
        numero: numero,
        bairro: bairro,
        complemento: complemento,
        pais: pais,
        estado: estado,
        cidade: cidade,
        grupo: grupo,
        inscricao_estadual: inscricao_estadual,
        inscricao_municipal: inscricao_municipal,
        telefone: telefone,
        contato: contato,
        email_contato: email_contato,
        email_nfe: email_nfe,
        email_boleto: email_boleto,
        cliente_desde: cliente_desde,
        situacao: situacao,
        observacao: observacao,
      }
    }

    if (id) { 
      data.row.id = id;
      api.put("/api/companies/put", data)
      .then((response) => {
          toast.success('Registro atualizado com sucesso.');
          history.push('/companies');
        }
      ).catch((error) => {
        console.log(error);
        showMessageError(error.response.data);
        setCarrying(false);
      });
    } else {
      api.post("/api/companies/post", data)
      .then((response) => {
          toast.success('Registro inserido com sucesso.');
          history.push('/companies');
        }
      ).catch((error) => {
        console.log(error);
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function getOne(id, option){
    api.get("/api/companies/getList?id=" + id)
    .then((response) => {
        setCnae(response.data.row.cnae);
        setCnpj(CNPJlib.format(response.data.row.cnpj));
        setRazaoSocial(response.data.row.razao_social);
        setNomeFantasia(response.data.row.nome_fantasia);
        setCep(response.data.row.cep);
        setLogradouro(response.data.row.logradouro);
        setNumero(response.data.row.numero);
        setBairro(response.data.row.bairro);
        setComplemento(response.data.row.complemento);
        setPais(response.data.row.pais);
        setEstado(response.data.row.estado);
        setCidade(response.data.row.cidade);
        setGrupo(response.data.row.grupo);
        setInscricaoEstadual(response.data.row.inscricao_estadual);
        setInscricaoMunicipal(response.data.row.inscricao_municipal);
        setTelefone(response.data.row.telefone);
        setContato(response.data.row.contato);
        setEmailContato(response.data.row.email_contato);
        setEmailNFE(response.data.row.email_nfe);
        setEmailBoleto(response.data.row.email_boleto);
        setClienteDesde(response.data.row.cliente_desde);
        setSituacao(response.data.row.situacao);
        setObservacao(response.data.row.observacao);
        setCarrying(false);
      }
    ).catch((error) => {
      console.log(error);
      showMessageError(error.response.data);
      setCarrying(false);
    });

    setView(changeDisable(option));
  }

  function cancel(){
    history.push('/companies');
  }

  function remove(){
    api.delete("/api/companies/delete?id=" + id)
    .then((response) => {
        toast.success('Registro excluído com sucesso.');
        history.push('/companies');
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }
  
  async function getData() {
    api.get("/api/companies/getDataPage")
    .then((response) => {
      setListCidades(response.data.cidades);
      setListEstados(response.data.estados);
      setListPaises(response.data.paises);
      setListGrupos(response.data.grupos_empresas);
      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }

  function searchCEP() {
    api.get("/api/utilities/getDataCEP?cep=" + cep)
    .then((response) => {
        setBairro(response.data.bairro);
        setCidade(response.data.localidade);
        setLogradouro(response.data.logradouro);
        setEstado(response.data.uf);
        setPais(response.data.pais);
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  function searchCNPJ() {
    if (!id && cnpj.length > 11) {
      api.get("/api/utilities/getDataCNPJ?cnpj=" + cnpj)
      .then((response) => {
          
        }
      ).catch((error) => {
        showMessageError(error.response.data);
      });
    }
  }

  function checkEmail(e) {
    if (!validateEmail(e.target.value)) {
      toast.error('E-mail inválido.');

      return '';
    }

    return e.target.value;
  }

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Cadastro de Empresas">
          <Link to="/companies">
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Cadastrais</h2>
              <hr></hr>
            
              <div className="divGroup">
                <div className="formDiv">
                  <label>Grupo</label>&nbsp;<label className="required">*</label><br/>
                  <select value={grupo} onChange={ (e) => setGrupo(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    {listGrupos.map((item, index) => (
                      <option key={index} value={item.id}>{item.nome}</option>
                    ))}
                  </select>
                </div>
                
                <div className="formDiv">
                  <label>Razão Social</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Razão Social" value={razao_social} onChange={ (e) => setRazaoSocial(e.target.value) } maxLength="100" disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>Nome Fantasia</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Nome Fantasia" value={nome_fantasia} onChange={ (e) => setNomeFantasia(e.target.value) } maxLength="50" disabled={view}/>
                </div>
                
                <div className="formDiv">
                  <label>CNPJ</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="CNPJ" value={cnpj} onChange={ (e) => setCnpj(setMaskGeneric(e.target.value, "##.###.###/####-##"))} onBlur={searchCNPJ} maxLength="18" disabled={view}/>
                </div>
              </div>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Inscrição Estadual</label><br/>
                  <input type="text" placeholder="Inscrição Estadual" value={inscricao_estadual} onChange={ (e) => setInscricaoEstadual(e.target.value) } maxLength="18" disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>Inscrição Municipal</label><br/>
                  <input type="text" placeholder="Inscrição Municipal" value={inscricao_municipal} onChange={ (e) => setInscricaoMunicipal(e.target.value) } maxLength="18" disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>CNAE</label><br/>
                  <input type="text" placeholder="CNAE" value={cnae} onChange={ (e) => setCnae(e.target.value) } maxLength="7" disabled={view}/>
                </div>
              </div>
            </div>
            <br/>
            <div className="containerGroupData">
              <h2>Endereço</h2>
              <hr></hr>
          
              <div className="divGroup">
                <div className="formDiv">
                  <label>CEP</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="CEP" value={cep} onChange={ (e) => setCep(setMaskGeneric(e.target.value, "#####-###")) } onBlur={searchCEP} maxLength="9" disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>Logradouro</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Logradouro" value={logradouro} onChange={ (e) => setLogradouro(e.target.value) } maxLength="120" disabled={view}/>
                </div> 

                <div className="formDiv">
                  <label>Número</label><br/>
                  <input type="text" placeholder="Número" value={numero} onChange={ (e) => setNumero(e.target.value) } maxLength="6" disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>Bairro</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Bairro" value={bairro} onChange={ (e) => setBairro(e.target.value) } maxLength="60" disabled={view}/>
                </div>
              </div>

              <div className="divGroup"> 
                <div className="formDiv">
                  <label>Estado</label>&nbsp;<label className="required">*</label><br/>
                  <select value={estado} onChange={ (e) => setEstado(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    {listEstados.map((item, index) => (
                      <option key={index} value={item.id}>{item.sigla} - {item.nome}</option>
                    ))}
                  </select>
                </div>

                <div className="formDiv">
                  <label>Cidade</label>&nbsp;<label className="required">*</label><br/>
                  <select value={cidade} onChange={ (e) => setCidade(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    {listCidades.map((item, index) => (
                      <option key={index} value={item.id}>{item.nome}</option>
                    ))}
                  </select>
                </div>

                <div className="formDiv">
                  <label>Complemento</label><br/>
                  <input type="text" placeholder="Complemento" value={complemento} onChange={ (e) => setComplemento(e.target.value) } maxLength="40" disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>Pais</label>&nbsp;<label className="required">*</label><br/>
                  <select value={pais} onChange={ (e) => setPais(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    {listPaises.map((item, index) => (
                      <option key={index} value={item.id}>{item.sigla} - {item.nome}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <br/>
            <div className="containerGroupData">
              <h2>Contato</h2>
              <hr></hr>

              <div className="divGroup">
                <div className="formDiv">
                  <label>E-mail Contato</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="E-mail Contato" value={email_contato} onChange={ (e) => setEmailContato(e.target.value) } maxLength="60" onBlur={checkEmail} disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>E-mail NFE</label><br/>
                  <input type="text" placeholder="E-mail NFE" value={email_nfe} onChange={ (e) => setEmailNFE(e.target.value) } maxLength="60" onBlur={checkEmail} disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>E-mail Boleto</label><br/>
                  <input type="text" placeholder="E-mail Boleto" value={email_boleto} onChange={ (e) => setEmailBoleto(e.target.value) } maxLength="60" onBlur={checkEmail} disabled={view}/>
                </div>
              </div>
              <div className="divGroup">  
                <div className="formDiv">
                  <label>Telefone</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Telefone" value={telefone} onChange={ (e) => setTelefone(setMaskGeneric(e.target.value, "(##)#####-####")) } maxLength="14" disabled={view}/>
                </div>
                <div className="formDiv">
                  <label>Contato</label><br/>
                  <input type="text" placeholder="Contato" value={contato} onChange={ (e) => setContato(e.target.value) } maxLength="40" disabled={view}/>
                </div>
              </div>
            </div>
            <br/>
            <div className="containerGroupData">
              <h2>Complemento</h2>
              <hr></hr>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Cadastro Desde</label><br/>
                  <input type="text" placeholder="##/##/####" value={cliente_desde} onChange={ (e) => setClienteDesde(setMaskGeneric(e.target.value, "##/##/####"))} maxLength="12" disabled={true}/>
                </div>

                <div className="formDiv">
                  <label>Situação</label><br/>
                  <select value={situacao} onChange={ (e) => setSituacao(e.target.value) } disabled={view}>
                    <option>Selecione</option>
                    <option value="S">Ativo</option>
                    <option value="N">Inativo</option>
                  </select>
                </div>
              </div>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Observação</label><br/>
                  <input type="text" placeholder="Observação" value={observacao} onChange={ (e) => setObservacao(e.target.value) } maxLength="360" disabled={view}/>
                </div>
              </div>  
            </div>
            {!view && <div className="formDiv">
              {getPermission('CADASTROS - EMPRESAS - CADASTRO') && <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Salvar</button>}
              <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
              {id && getPermission('CADASTROS - EMPRESAS - EXCLUSAO') && <button type="button" className="buttonRemove" onClick={remove} disabled={view}>Excluir</button>}
            </div>}
          </form>
        </div>
      </div>}
    </div>
  )
}